import {
  useQueryStates,
  parseAsArrayOf,
  parseAsInteger,
  parseAsStringLiteral,
} from 'nuqs'
import {
  PositionStatusFilter,
  PrescreenStatusFilter,
} from 'api/positions/getAllPositions'

const statusParser = parseAsStringLiteral<PositionStatusFilter>([
  'approved',
  'unapproved',
  'all',
])

const prescreenStatusParser = parseAsStringLiteral<PrescreenStatusFilter>([
  'prescreened',
  'not-prescreened',
  'all',
])

export const usePositionQueryState = () => {
  const queryStates = useQueryStates(
    {
      positionIds: parseAsArrayOf(parseAsInteger).withDefault([]),
      status: statusParser.withDefault('all'),
      prescreenStatus: prescreenStatusParser.withDefault('all'),
    },
    {
      urlKeys: {
        positionIds: 'position-ids',
        status: 'status',
        prescreenStatus: 'prescreen-status',
      },
    }
  )

  return queryStates
}
